export const assetPrefix = process.env.NEXT_PUBLIC_ASSET_PREFIX ? process.env.NEXT_PUBLIC_ASSET_PREFIX + "/" : "/";
const assetUrl = process.env.NEXT_PUBLIC_ASSETS_URL || "/assets/";

export const micrositePrefix = process.env.NEXT_PUBLIC_DOMAIN_MICROSITE ? `https://${process.env.NEXT_PUBLIC_DOMAIN_MICROSITE}/` : "/"

export default assetUrl;
